// API Configuration
// In development, point to local Express server
// In production on Vercel, API is same-origin at /api
const API_BASE_URL = process.env.NODE_ENV === 'development'
  ? 'http://localhost:5001'
  : '/api';

export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH_LOGIN: `${API_BASE_URL}/auth/login`,
  AUTH_STATUS: `${API_BASE_URL}/auth/status`,
  LOGOUT: `${API_BASE_URL}/auth/logout`,

  // API endpoints
  PROFILES: `${API_BASE_URL}/profiles`,
  PERMISSION_SETS: `${API_BASE_URL}/permissionsets`,
  COMPARE_PROFILES: `${API_BASE_URL}/compare/profiles`,
  EXPORT: `${API_BASE_URL}/export`,

  // Documentation Engine endpoints
  DOCUMENTATION_STATUS: `${API_BASE_URL}/documentation/status`,
  DOCUMENTATION_SCAN: `${API_BASE_URL}/documentation/scan`,
  DOCUMENTATION_SCAN_CONTINUE: `${API_BASE_URL}/documentation/scan/continue`,
  DOCUMENTATION_OBJECTS: `${API_BASE_URL}/documentation/objects`,
  DOCUMENTATION_SEARCH: `${API_BASE_URL}/documentation/search`,
  DOCUMENTATION_GENERATE: `${API_BASE_URL}/documentation/generate`,
  DOCUMENTATION_CONTEXT: `${API_BASE_URL}/documentation/context`,
  DOCUMENTATION_SELECT_OBJECTS: `${API_BASE_URL}/documentation/select-objects`,
  DOCUMENTATION_DEPLOY: `${API_BASE_URL}/documentation/deploy`,
  DOCUMENTATION_IGNORED_OBJECTS: `${API_BASE_URL}/documentation/objects/ignored`,
  DOCUMENTATION_EXPORT_DATA_DICTIONARY: `${API_BASE_URL}/documentation/export/data-dictionary`,
  DOCUMENTATION_PACK_GENERATE: `${API_BASE_URL}/documentation/pack`,
  DOCUMENTATION_PACKS: `${API_BASE_URL}/documentation/packs`,
  DOCUMENTATION_PACK_DOWNLOAD: (id) => `${API_BASE_URL}/documentation/pack/${id}/download`,

  // Automation inventory endpoints
  DOCUMENTATION_AUTOMATIONS_SCAN: `${API_BASE_URL}/documentation/automations/scan`,
  DOCUMENTATION_AUTOMATIONS: `${API_BASE_URL}/documentation/automations`,

  // Flow Documentation endpoints
  DOCUMENTATION_FLOWS: `${API_BASE_URL}/documentation/flows`,
  DOCUMENTATION_FLOWS_SCAN: `${API_BASE_URL}/documentation/flows/scan`,
  DOCUMENTATION_FLOWS_SCAN_CONTINUE: `${API_BASE_URL}/documentation/flows/scan/continue`,
  DOCUMENTATION_FLOWS_GENERATE: `${API_BASE_URL}/documentation/flows/generate`,
  DOCUMENTATION_FLOWS_SELECT: `${API_BASE_URL}/documentation/flows/select`,
  DOCUMENTATION_FLOWS_CONNECTIONS: `${API_BASE_URL}/documentation/flows/connections`,

  // Graph Explorer endpoints
  DOCUMENTATION_GRAPH_NODES: `${API_BASE_URL}/documentation/graph/nodes`,
  DOCUMENTATION_GRAPH_LOOPS: `${API_BASE_URL}/documentation/graph/loops`,
  DOCUMENTATION_GRAPH_NEIGHBORHOOD: (nodeId, depth) => `${API_BASE_URL}/documentation/graph/neighborhood?node=${encodeURIComponent(nodeId)}&depth=${depth}`,

  // Permissions Editor endpoints
  PERMISSIONS_VALIDATE: `${API_BASE_URL}/permissions/validate`,
  PERMISSIONS_DEPLOY: `${API_BASE_URL}/permissions/deploy`,
  PERMISSIONS_CREATE_SET: `${API_BASE_URL}/permissions/create-permission-set`,

  // Advisor endpoints
  ADVISOR_ANALYZE: `${API_BASE_URL}/advisor/analyze`,
  ADVISOR_REPORTS: `${API_BASE_URL}/advisor/reports`,

  // Deployment Review endpoints
  DEPLOYMENTS_HISTORY: `${API_BASE_URL}/deployments/history`,
  DEPLOYMENTS_PERMISSIONS: `${API_BASE_URL}/deployments/permissions`,
  DEPLOYMENTS_RECOMMEND: `${API_BASE_URL}/deployments/recommend`,
  DEPLOYMENTS_APPLY: `${API_BASE_URL}/deployments/apply`,
  DEPLOYMENTS_LAST_CHECK: `${API_BASE_URL}/deployments/last-check`,
};

export default API_ENDPOINTS;
